import {
    TableCellText,
  } from "@ceridianhcm/components";
  import { FormatCurrency } from "../../../../common/formatting";
  
  export const PayFileGarnishmentColumnsDefinitions = () => {
    return [
      {
        
        field: "PaymentType",
        label: "Payment Type",
        cellTemplate: (cellContext: any) => (
          <TableCellText>
            <div title={cellContext.rowData.paymentType}>
              {cellContext.rowData.paymentType}
            </div>
          </TableCellText>
        ),
      },
      {
        field: "CaseNumber",
        label: "Case Number",
        cellTemplate: (cellContext: any) => (
          <TableCellText>
            <div title={cellContext.rowData.caseNumber}>
              {cellContext.rowData.caseNumber}
            </div>
          </TableCellText>
        ),
      },
      {
          field: "Name",
          label: "Name",
          cellTemplate: (cellContext: any) => (
            <TableCellText>
              <div title={cellContext.rowData.name}>
                {cellContext.rowData.name}
              </div>
            </TableCellText>
          ),
        },
        {
          field: "PayeeId",
          label: "PayeeId",
          cellTemplate: (cellContext: any) => (
            <TableCellText>
              <div title={cellContext.rowData.payeeId}>
                {cellContext.rowData.payeeId}
              </div>
            </TableCellText>
          ),
        },
      {
        field: "Amount",
        label: "Amount",
        cellTemplate: (cellContext: any) => (
          <TableCellText>
            <div title={cellContext.rowData.amount}>
              {FormatCurrency(cellContext.rowData.amount)}
            </div>
          </TableCellText>
        ),
      }
    ];
  };
